import { Injectable } from '@angular/core';
import { DeliveryReceiptItem } from '../types/IDeliveryReceiptItem';

@Injectable({
    providedIn: 'root',
})
export class DeliveryReceiptDetailService {
    public groupItemsByOrder(items: DeliveryReceiptItem[]): Map<string, DeliveryReceiptItem[]> {
        const map = new Map<string, DeliveryReceiptItem[]>();
        for (const item of items) {
            if (!map.has(item.orderNumber)) {
                map.set(item.orderNumber, []);
            }

            map.get(item.orderNumber).push(item);
        }

        return map;
    }
}
